<div class="row">
  <div class="col-12 col-md-4 mb-5">
    <div class="row" [formGroup]="form">
      <div class="col-12 mb-3">
        <lib-gung-text-input gungTranslate="ARTICLE_WORKING_ORDER" formControlName="id"
          [placeholder]="''"></lib-gung-text-input>
        <lib-forms-message-error [controller]="form.get('id')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-area-input gungTranslate="DESCRIPTION_WORKING_ORDER" formControlName="description"
          [placeholder]="''" [rowsNumber]="3"></lib-gung-text-area-input>
        <lib-forms-message-error [controller]="form.get('description')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-number-input gungTranslate="NET_PRICE" formControlName="price"
          [placeholder]="''"></lib-gung-number-input>
        <lib-forms-message-error [controller]="form.get('price')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-number-input gungTranslate="GROSS_PRICE_WORKING_ORDER" formControlName="grossPrice"
          [placeholder]="''"></lib-gung-number-input>
        <lib-forms-message-error [controller]="form.get('grossPrice')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-number-input gungTranslate="QUANTITY" formControlName="qty"
          [placeholder]="''"></lib-gung-number-input>
        <lib-forms-message-error [controller]="form.get('qty')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <button class="btn btn-primary w-100" (click)="addToWorkingOrder($event)" [disabled]="form.invalid"
          translate>ADD_TO_WORKING_ORDER</button>
      </div>

      <div class="col-12">
        <div *ngIf="noExtrasSelected" class="alert alert-danger" translate>NO_EXTRAS_SELECTED_ERROR</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-8 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>ARTICLE_WORKING_ORDER</th>
          <th translate>DESCRIPTION_WORKING_ORDER</th>
          <th translate>GROSS_PRICE_WORKING_ORDER</th>
          <th translate>QUANTITY</th>
          <th translate>NET_PRICE</th>
          <th style="width: 50px" translate></th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.extras; let index = index">
          <td [attr.data-label]="'ARTICLE_WORKING_ORDER' | translate">
            <a>{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'DESCRIPTION_WORKING_ORDER' | translate">
            <a>{{ row.description }}</a>
          </td>
          <td [attr.data-label]="'GROSS_PRICE_WORKING_ORDER' | translate">
            {{ row.extra.grossPrice }}
          </td>
          <td [attr.data-label]="'QUANTITY' | translate">
            {{ row.extra.qty }}
          </td>
          <td [attr.data-label]="'NET_PRICE' | translate">
            {{ row.price }}
          </td>
          <td [attr.data-label]="'' | translate">
            <div class="d-flex flex-row w-100 justify-content-end">
              <button class="btn btn-sm btn-outline-secondary delete-button mr-1"
                (click)="removeFromWorkingOrder(index)">
                <i class="fal fa-minus-circle"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="alert alert-info mt-4">
      <p translate>WORKING_ORDER_STEP_INFO_4</p>
    </div>
  </div>
</div>
